var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.16663 13.8333L10.5 10.5M10.5 10.5L13.8333 13.8333M10.5 10.5V18M17.1666 14.4524C18.1845 13.6117 18.8333 12.3399 18.8333 10.9167C18.8333 8.38536 16.7813 6.33333 14.25 6.33333C14.0679 6.33333 13.8975 6.23833 13.8051 6.08145C12.7183 4.23736 10.712 3 8.41663 3C4.96485 3 2.16663 5.79822 2.16663 9.25C2.16663 10.9718 2.86283 12.5309 3.98908 13.6613",
    stroke: "#344054",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.bd01a38030d19769f27a1896a2d0c220.svg";
export { ForwardRef as ReactComponent };